import { Form, Formik, FormikHelpers } from "formik";
import React from "react";
import * as Yup from "yup";
import CustomModal from "../../../../../ui/customModal";
import TextField from "../../../../../ui/customFields/text";
import Button from "../../../../../ui/button";
import { ButtonsRow, FieldRow, SubTitle } from "./Styles";

const PasswordSchema = Yup.object().shape({
  current_password: Yup.string()
    .min(6, "Senha muito curta")
    .required("Senha atual é obrigatória"),
});

type FormValues = { current_password: string };

type Props = {
  show: boolean;
  onSubmit: (values: FormValues, actions: FormikHelpers<FormValues>) => void;
  onCancel?: () => void;
};

const PasswordConfirmationModal: React.FC<Props> = ({
  show,
  onSubmit,
  onCancel,
}) => {
  return (
    <CustomModal show={show} header="Confirme sua senha">
      <Formik
        initialValues={{
          current_password: "",
        }}
        validationSchema={PasswordSchema}
        onSubmit={onSubmit}
      >
        {({ isValid, dirty, isSubmitting }) => (
          <Form>
            <SubTitle>
              Por favor, insira sua senha atual para confirmar as alterações:
            </SubTitle>

            <FieldRow>
              <TextField
                name="current_password"
                label="Senha atual"
                type="password"
              />
            </FieldRow>

            <ButtonsRow>
              <Button
                variant="light"
                type="button"
                onClick={onCancel}
                disabled={isSubmitting}
              >
                Cancelar
              </Button>

              <Button
                variant="primary"
                type="submit"
                disabled={isSubmitting || !isValid || !dirty}
              >
                {isSubmitting ? "Verificando..." : "Confirmar"}
              </Button>
            </ButtonsRow>
          </Form>
        )}
      </Formik>
    </CustomModal>
  );
};

export default PasswordConfirmationModal;
